// extracted by mini-css-extract-plugin
export default {"avatarHeader":"avatarHeader__oG4zmcJWFvK4","strong":"strong__gczu6VjKuoo7","buttonIcon":"buttonIcon__IYfufGbNzkGB","button":"button__cUfu1WpSJs4O"};